export default "__VITE_ASSET__Dfioxzjy__"